import { LoggerService } from "@Front/Services/LoggerService/LoggerService";
import { ssoAuthorizeBaseUrlFromEnv, ssoOAuthPublicCallbackUrl, resolveEffectiveSsoOAuthClientId } from "./ssoOAuthBrowserUrls";
import { startSsoPkceAuthorizeRedirect } from "./ssoOauthPkceSession";

/**
 * Redirige le navigateur vers sso-back `/oauth/authorize` (PKCE S256, aligné portail).
 *
 * @param loginHintEmail — optional `login_hint` (e.g. Enso demo account email).
 * @param clientIdOverride — optional `client_id` from `GET /v1/public/site-config` when build-time env is empty.
 */
export async function redirectSsoProfessionalToAuthorize(loginHintEmail?: string, clientIdOverride?: string | null): Promise<void> {
	const clientId = resolveEffectiveSsoOAuthClientId(clientIdOverride);
	if (!clientId) {
		LoggerService.error("[Login] SSO OAuth client_id manquant (site-config et NEXT_PUBLIC_SSO_OAUTH_CLIENT_ID)");
		return;
	}
	const redirectUri = ssoOAuthPublicCallbackUrl();
	const trimmedHint = loginHintEmail?.trim();
	try {
		await startSsoPkceAuthorizeRedirect({
			clientId,
			authorizeBaseUrl: ssoAuthorizeBaseUrlFromEnv(),
			redirectUri,
			loginHint: trimmedHint && trimmedHint.length > 0 ? trimmedHint : undefined,
		});
	} catch (e) {
		LoggerService.error("[Login] Impossible de démarrer la redirection SSO OAuth PKCE", { error: e });
	}
}
